import status from "./status";
import * as ActionTypes from "../../actions";

//Updates the status apiCalls data for different api call.
var notificationListItemApiCalls = {
  loadNotificationListItemsByUserId: status({
    mapActionToKey: function mapActionToKey(action) {
      return action.userId.toString();
    },
    types: [ActionTypes.GET_NOTIFICATIONTOASTSBYUSERID_REQUEST, ActionTypes.GET_NOTIFICATIONTOASTSBYUSERID_SUCCESS, ActionTypes.GET_NOTIFICATIONTOASTSBYUSERID_FAILURE, ActionTypes.RESET_GET_NOTIFICATIONTOASTSBYUSERID]
  }),
  loadNotificationListItemsByUserIdAndViewedAtIsNull: status({
    mapActionToKey: function mapActionToKey(action) {
      return action.userId.toString();
    },
    types: [ActionTypes.GET_NOTIFICATIONTOASTSBYUSERIDANDVIEWEDATISNULL_REQUEST, ActionTypes.GET_NOTIFICATIONTOASTSBYUSERIDANDVIEWEDATISNULL_SUCCESS, ActionTypes.GET_NOTIFICATIONTOASTSBYUSERIDANDVIEWEDATISNULL_FAILURE, ActionTypes.RESET_GET_NOTIFICATIONTOASTSBYUSERIDANDVIEWEDATISNULL]
  })
};
export default notificationListItemApiCalls;